import type { PriceInfoViewModel, ProductListPriceInfo } from 'autogen/swagger/all';
import type { PriceModuleProps } from './types';

function mapPriceInfoViewModelToPriceModuleProps(props: PriceInfoViewModel): PriceModuleProps {
    const { price, priceLabel, priceBefore, saveLabel, recommendedPriceLabel, minimumSalesQuantity, onDiscount } =
        props;

    return {
        price,
        priceLabel: priceLabel || undefined,
        priceBefore,
        saveLabel,
        recommendedPriceLabel,
        minimumSalesQuantity,
        isOnDiscount: onDiscount
    };
}

function mapProductListPriceInfoToPriceModuleProps(props: ProductListPriceInfo): PriceModuleProps {
    const { price, priceLabel, priceBefore, pricePrefix, recommendedPriceLabel, minimumSalesQuantity, isOnDiscount } =
        props;

    return {
        price,
        priceLabel: priceLabel || undefined,
        priceBefore,
        pricePrefix,
        recommendedPriceLabel,
        minimumSalesQuantity,
        isOnDiscount
    };
}

export { mapPriceInfoViewModelToPriceModuleProps, mapProductListPriceInfoToPriceModuleProps };
